import {createFileRoute, Outlet} from "@tanstack/react-router";
import {AdminTableOnlyPage} from "~/components/adminDocs/adminTableOnlyPage";
import {searchSchema} from "~/modules/dataPipeline/model";
export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/data-pipeline")({
    validateSearch: (search) => searchSchema.parse(search),
    loader: ({context}) => ({accessToken: context.authenticationStatus.accessToken, intellsysBaseUrl: context.intellsysBaseUrl}),
    component: Layout,
});

function Layout() {
    return (
        <AdminTableOnlyPage
            {...Route.useLoaderData()}
            moduleDocSlug="data-pipeline"
            title="Data Pipeline"
            hideTitleSection
            bottomSection={<Outlet />}
        />
    );
}
